import React from 'react';
export function FooterSection() {
  return <footer className="w-full bg-darkernavy py-12 px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-102">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-103">
        <div className="flex items-center gap-3 mb-6" data-id="element-104">
          <div className="w-8 h-8 bg-gold/20 rounded-full flex items-center justify-center border border-gold/50" data-id="element-105">
            <span className="text-sm" data-id="element-106">🤖</span>
          </div>
          <span className="font-playfair font-bold text-xl text-white" data-id="element-107">
            IA Práctica para Docentes
          </span>
        </div>

        <p className="font-inter text-sm text-gray-400 mb-6" data-id="element-108">
          © 2025 — Todos los derechos reservados
        </p>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 font-inter text-sm text-gray-500 mb-8" data-id="element-109">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-110">
            Política de Privacidad
          </a>
          <span className="hidden sm:inline text-gray-700" data-id="element-111">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-112">
            Términos y Condiciones
          </a>
          <span className="hidden sm:inline text-gray-700" data-id="element-113">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-114">
            Contacto
          </a>
        </div>

        <p className="font-inter text-xs text-gray-600 max-w-2xl mx-auto" data-id="element-115">
          Este producto es una guía digital educativa. Los resultados pueden
          variar según el uso individual, el nivel de implementación y el
          contexto educativo específico de cada docente.
        </p>
      </div>
    </footer>;
}